<template>
  <div style="position: relative">
    <!-- ***ใส่ filter sort*** -->
    <v-layout wrap align-center class="mt-4">
      <v-flex xs4 sm4 md6 class="main-title">
        FREE DELIVERY
        <v-btn
          round
          small
          depressed
          color="blue"
          class="white--text"
          style="cursor: text"
          >free</v-btn
        >
      </v-flex>
      <v-flex xs10 sm4 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm3 d-flex class="text-xs-center">
        <v-btn
          icon
          style="position: absolute; top: 10px; right: 10px"
          @click="exportFile('xlsx')"
        >
          <v-icon large color="black">print</v-icon>.xlsx
        </v-btn>
        <v-btn
          icon
          style="position: absolute; top: 10px; right: 90px"
          @click="exportFile('csv')"
        >
          <v-icon large color="black">print</v-icon>.csv
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="freedelivery_order_report"
      class="elevation-1"
      style="background-color: white; padding: 10px; border-radius: 10px"
    >
      <template
        slot="headerCell"
        slot-scope="props1"
        style="background-color: black"
        >{{ props1.header.text }}</template
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td>{{ props.item.Order_code }}</td>
        <td>{{ props.item.order_base_code }}</td>
        <td>{{ props.item.Date_time }}</td>
        <td>{{ props.item.Store }}</td>
        <td>{{ props.item.Customer }}</td>
        <td class="text-xs-center">
          {{ props.item.order_payment }}
        </td>
        <td
          :style="
            props.item.Status == 'completed' ? 'color:green;' : 'color:red;'
          "
        >
          {{ props.item.Status }}
        </td>
        <!-- <td style="color:green;">{{ props.item.order_status }}</td> -->
        <td style="white-space: pre-wrap">{{ props.item.admin_note }}</td>
        <td class="text-xs-center">
          <v-btn
            small
            color="primary"
            class="black--text"
            :to="
              '/weserve_admin_login/control/' +
              $store.state.backOffice.province +
              '/report/order_report/order_detail/' +
              props.item.order_id +
              '/food'
            "
            >detail</v-btn
          >
        </td>
      </template>
      <!-- <template slot="footer">
        <td colspan="3" class="text-xs-center">
          <strong>Total</strong>
        </td>
        <td>xxxx</td>
      </template>-->
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { utils, writeFile } from "xlsx";
export default {
  data() {
    return {
      exportFields: {
        No: "no",
        "Order code": "Order_code",
        "Order ref.": "order_base_code",
        "Date/time": "Date_time",
        "Store name": "Store",
        "Customer name": "Customer",
        "Payment type": "order_payment",
        Status: "Status",
        "Admin note": "admin_note",
      },
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "no",
        },
        { text: "Order Code", value: "order_code", sortable: false },
        { text: "Order ref.", value: "order_base_code", sortable: false },
        {
          text: "Date/Time",
          value: "order_time_start",
          align: "center",
          sortable: false,
        },
        { text: "Store", value: "order_store", sortable: false },
        {
          text: "Customer",
          value: "order_customer_full_name",
          sortable: false,
        },
        {
          text: "Payment type",
          value: "order_payment",
          sortable: false,
        },
        { text: "Status", value: "order_status", sortable: false },
        { text: "Admin note", value: "admin_note", sortable: false },
        { text: "Order detail", sortable: false, align: "center" },
      ],
      column_items: [
        { text: "Store name", value: "Store", sortable: false },
        {
          text: "Customer",
          value: "Customer",
          sortable: false,
        },
      ],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false,
    };
  },
  watch: {
    freedelivery_order_report() {
      if (this.isSort == false) {
        this.asc_desc = "asc";
        this.sort_column = "no_default";
      }
    },
  },
  computed: {
    ...mapState({
      freedelivery_order_report: (state) =>
        state.fetchReportDashboard.freedelivery_order_report,
      search_config: (state) => state.fetchReportDashboard.search_config,
      export_freedelivery_format: (state) =>
        state.fetchReportDashboard.export_freedelivery_format,
    }),
  },
  methods: {
    exportFile(format) {
      const fields = this.exportFields;
      const rows = this.export_freedelivery_format.map((row) =>
        Object.keys(fields).map((label) => row[fields[label]] == null ? "" : row[fields[label]])
      );
      const sheet = utils.aoa_to_sheet([Object.keys(fields), ...rows]);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, sheet, "Order report");
      writeFile(workbook, `OrderReport-FreeDelivery_${this.search_config.datetime_start}_to_${this.search_config.datetime_end}.${format}`);
    },
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.freedelivery_order_report,
        field: this.sort_column,
        asc_desc: this.asc_desc,
      };

      await this.$store.dispatch("sortData", send_json_data);
      this.$store.commit("fetchReportDashboard/getExportFreeDeliveryReport");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    },
  },
  created() {},
};
</script>
<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
</style>
